import { apiFetch } from "@/lib/api/client";

export type SearchResultType = "member" | "plan" | "invoice";

export interface SearchResult {
  type: SearchResultType;
  id: string;
  label: string;
  sub: string;
  url: string;
}

export interface GlobalSearchResponse {
  members: SearchResult[];
  plans: SearchResult[];
  invoices: SearchResult[];
}

export async function globalSearch(q: string): Promise<GlobalSearchResponse> {
  return apiFetch(`/search/?q=${encodeURIComponent(q)}`, { method: "GET" });
}
